import React, { useMemo } from "react";
import { useHomeContext } from "../../../context/Home_context";
import "../../home/homeourpartner/HomeOurPartner.css";

const EditionOurPartner = ({ data }) => {
  const { edition_expo_data } = useHomeContext();
  const expoData = data || edition_expo_data || {};

  const categories = useMemo(() => {
    if (expoData?.sponser_categories) {
      return expoData.sponser_categories;
    }
    if (expoData?.sponser_category_data) {
      return expoData.sponser_category_data;
    }
    if (expoData?.sponsers) {
      return [
        { id: 1, name: "Our Partners & Sponsors", sponsers: expoData.sponsers },
      ];
    }
    return [];
  }, [expoData]);

  const activeCategories = Array.isArray(categories)
    ? categories.filter((cat) => cat.sponsers && cat.sponsers.length > 0)
    : [];

  if (activeCategories.length === 0) return null;

  return (
    <section className="clean-brands-section" id="brands-partners">
      <div className="clean-brands-container">
        {activeCategories.map((category, catIdx) => {
          const sponsorCount = category.sponsers ? category.sponsers.length : 0;
          const gridColsClass =
            sponsorCount === 1
              ? "cols-1"
              : sponsorCount === 2
                ? "cols-2"
                : sponsorCount === 3
                  ? "cols-3"
                  : "cols-4";

          const categorySizeClass =
            sponsorCount <= 2
              ? "cat-size-small"
              : sponsorCount === 3
                ? "cat-size-medium"
                : "cat-size-large";

          return (
            <div
              key={category.id || catIdx}
              className={`partner-row-section ${categorySizeClass}`}
            >
              <div className="partner-row-grid">
                <div className="partner-group-column wide-column">
                  {category.name && (
                    <div className="partner-header-wrapper">
                      <span className="partner-heading-badge theme-blue">
                        {category.name}
                      </span>
                    </div>
                  )}

                  <div className="partner-logos-flex-wrapper">
                    <div className={`partner-logos-grid ${gridColsClass}`}>
                      {category.sponsers.map((sponser, sIdx) => {
                        const imgSrc = sponser.image_full_path || sponser.image;
                        const name =
                          sponser.company_name || sponser.name || "Sponsor";
                        const link = sponser.link;

                        const content = (
                          <>
                            <div className="partner-logo-imgwrap">
                              {imgSrc ? (
                                <img
                                  src={imgSrc}
                                  alt={name}
                                  className="partner-svg-logo"
                                  decoding="async"
                                />
                              ) : (
                                <span className="partner-text-logo">
                                  {name}
                                </span>
                              )}
                            </div>
                            <span className="partner-company-name" title={name}>
                              {name}
                            </span>
                          </>
                        );

                        if (link) {
                          return (
                            <a
                              key={sponser.id || sIdx}
                              href={link}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="clean-logo-card"
                              title={name}
                            >
                              {content}
                            </a>
                          );
                        }
                        return (
                          <div
                            key={sponser.id || sIdx}
                            className="clean-logo-card"
                          >
                            {content}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default EditionOurPartner;
